import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function MentionsLegales() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language || 'fr';

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <button
          onClick={() => navigate('/')}
          className="text-primary-600 hover:text-primary-700 font-semibold mb-6"
        >
          ← {lang === 'fr' ? 'Retour' : 'Back'}
        </button>

        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          {lang === 'fr' ? 'Mentions Légales' : 'Legal Notice'}
        </h1>

        {lang === 'fr' ? (
          <>
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Éditeur du site</h2>
              <p className="text-gray-700 mb-2">
                <strong>Nom et prénom :</strong> MOMO KOUNTCHOU Arthur
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Raison sociale :</strong> BEL-AN Prod
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Forme juridique :</strong> Entrepreneur Individuel
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Siège social :</strong> 28 Rue de Courdimanche, 91940 Les Ulis, France
              </p>
              <p className="text-gray-700 mb-2">
                <strong>SIRET :</strong> 992 616 011 00019
              </p>
              <p className="text-gray-700 mb-2">
                <strong>TVA intracommunautaire :</strong> TVA non applicable, art. 293B du CGI
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Email :</strong> ace.direction22@gmail.com
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Téléphone :</strong> +33 7 50 14 93 98
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Directeur de publication :</strong> Arthur MOMO KOUNTCHOU
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Hébergement</h2>
              <p className="text-gray-700 mb-2">
                Le site ProjectBoost est hébergé par :
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Google Cloud Platform (Firebase)</strong>
              </p>
              <p className="text-gray-700 mb-2">
                Google Ireland Limited<br />
                Gordon House, Barrow Street<br />
                Dublin 4, Irlande
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Site web :</strong> <a href="https://firebase.google.com" className="text-primary-600 hover:underline">firebase.google.com</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Propriété intellectuelle</h2>
              <p className="text-gray-700 mb-4">
                L'ensemble du contenu de ce site (textes, images, graphismes, logos, icônes, sons, logiciels, etc.) 
                est la propriété exclusive de BEL-AN Prod et du Dr. Arthur MOMO KOUNTCHOU, sauf mention contraire.
              </p>
              <p className="text-gray-700 mb-4">
                Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des 
                éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation 
                écrite préalable.
              </p>
              <p className="text-gray-700 mb-4">
                Les livres disponibles dans la bibliothèque sont protégés par le droit d'auteur. Leur consultation 
                est réservée aux abonnés Gold dans le cadre d'un usage strictement personnel et non commercial.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Données personnelles</h2>
              <p className="text-gray-700 mb-4">
                Pour plus d'informations sur la collecte et le traitement de vos données personnelles, 
                veuillez consulter notre <a href="/confidentialite" className="text-primary-600 hover:underline">Politique de Confidentialité</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Cookies</h2>
              <p className="text-gray-700 mb-4">
                Ce site utilise des cookies pour améliorer votre expérience utilisateur. 
                Pour en savoir plus, consultez notre <a href="/cookies" className="text-primary-600 hover:underline">Politique de Cookies</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Responsabilité</h2>
              <p className="text-gray-700 mb-4">
                BEL-AN Prod met tout en œuvre pour offrir aux utilisateurs des informations et/ou outils disponibles 
                et vérifiés, mais ne saurait être tenu pour responsable des erreurs, d'une absence de disponibilité 
                des informations et/ou de la présence de virus sur son site.
              </p>
              <p className="text-gray-700 mb-4">
                Les diagnostics fournis par ProjectBoost sont des outils d'aide à la décision et ne constituent pas 
                des audits de conformité ni des conseils professionnels. Ils ne sauraient engager la responsabilité 
                de BEL-AN Prod en cas de décisions prises sur leur base.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Liens hypertextes</h2>
              <p className="text-gray-700 mb-4">
                Le site peut contenir des liens hypertextes vers d'autres sites. BEL-AN Prod n'exerce aucun 
                contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Droit applicable</h2>
              <p className="text-gray-700 mb-4">
                Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux 
                français seront seuls compétents.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Contact</h2>
              <p className="text-gray-700 mb-4">
                Pour toute question concernant les mentions légales, vous pouvez nous contacter à l'adresse : 
                <a href="mailto:ace.direction22@gmail.com" className="text-primary-600 hover:underline ml-1">
                  ace.direction22@gmail.com
                </a>
              </p>
            </section>
          </>
        ) : (
          <>
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Website Publisher</h2>
              <p className="text-gray-700 mb-2">
                <strong>Name:</strong> MOMO KOUNTCHOU Arthur
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Company name:</strong> BEL-AN Prod
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Legal form:</strong> Individual Entrepreneur
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Registered office:</strong> 28 Rue de Courdimanche, 91940 Les Ulis, France
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Company registration number:</strong> 992 616 011 00019
              </p>
              <p className="text-gray-700 mb-2">
                <strong>VAT number:</strong> VAT not applicable, art. 293B of the French Tax Code
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Email:</strong> ace.direction22@gmail.com
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Phone:</strong> +33 7 50 14 93 98
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Publication director:</strong> Arthur MOMO KOUNTCHOU
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Hosting</h2>
              <p className="text-gray-700 mb-2">
                The ProjectBoost website is hosted by:
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Google Cloud Platform (Firebase)</strong>
              </p>
              <p className="text-gray-700 mb-2">
                Google Ireland Limited<br />
                Gordon House, Barrow Street<br />
                Dublin 4, Ireland
              </p>
              <p className="text-gray-700 mb-2">
                <strong>Website:</strong> <a href="https://firebase.google.com" className="text-primary-600 hover:underline">firebase.google.com</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Intellectual Property</h2>
              <p className="text-gray-700 mb-4">
                All content on this website (texts, images, graphics, logos, icons, sounds, software, etc.) 
                is the exclusive property of BEL-AN Prod and Dr. Arthur MOMO KOUNTCHOU, unless otherwise stated.
              </p>
              <p className="text-gray-700 mb-4">
                Any reproduction, representation, modification, publication, or adaptation of all or part of the 
                website elements, regardless of the means or process used, is prohibited without prior written authorization.
              </p>
              <p className="text-gray-700 mb-4">
                The books available in the library are protected by copyright. Their consultation is reserved for 
                Gold subscribers for strictly personal and non-commercial use.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Personal Data</h2>
              <p className="text-gray-700 mb-4">
                For more information about the collection and processing of your personal data, please consult our{" "}
                <a href="/confidentialite" className="text-primary-600 hover:underline">Privacy Policy</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Cookies</h2>
              <p className="text-gray-700 mb-4">
                This website uses cookies to improve your user experience. 
                For more information, see our <a href="/cookies" className="text-primary-600 hover:underline">Cookie Policy</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Liability</h2>
              <p className="text-gray-700 mb-4">
                BEL-AN Prod makes every effort to provide users with available and verified information and/or tools, 
                but cannot be held responsible for errors, unavailability of information and/or the presence of viruses on its website.
              </p>
              <p className="text-gray-700 mb-4">
                The diagnostics provided by ProjectBoost are decision-support tools and do not constitute compliance 
                audits or professional advice. BEL-AN Prod cannot be held liable for decisions made based on them.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Hyperlinks</h2>
              <p className="text-gray-700 mb-4">
                The website may contain hyperlinks to other sites. BEL-AN Prod exercises no control over these 
                sites and disclaims all responsibility for their content.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Applicable Law</h2>
              <p className="text-gray-700 mb-4">
                These legal notices are governed by French law. In case of dispute, French courts shall have 
                sole jurisdiction.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Contact</h2>
              <p className="text-gray-700 mb-4">
                For any questions regarding legal notices, you can contact us at: 
                <a href="mailto:ace.direction22@gmail.com" className="text-primary-600 hover:underline ml-1">
                  ace.direction22@gmail.com
                </a>
              </p>
            </section>
          </>
        )}

        <div className="mt-12 pt-8 border-t border-gray-200 text-center text-sm text-gray-500">
          <p>© 2026 BEL-AN Prod - ProjectBoost. {lang === 'fr' ? 'Tous droits réservés.' : 'All rights reserved.'}</p>
        </div>
      </div>
    </div>
  );
}

export default MentionsLegales;
